import { createElement, memo, useCallback, useEffect } from '@max/max';
import View from '@hfe/max-view';
import LText from '@max/leez-text';
import Button from '@hfe/max-button';
import LIcon from '@max/leez-icon';
import { flattenStyle } from '@max/leez-style-util';
import { _remStyle, _remStyleSheet } from '../../utils/style';
const isWeb = true;
const isMRN = false;
import ImageTab from './ImageTab';
import './index.scss';
const renderTextTab = (tabItems, activeIndex, onTabClick, tabTheme) => {
    const styles = _remStyleSheet({
        tagText: {
            fontSize: 28,
            lineHeight: 32,
            fontWeight: '500',
            color: '#222222'
        },
        tagTextActive: {
            fontSize: 28,
            lineHeight: 32,
            fontWeight: '500',
            color: tabTheme.titleActiveColor
        }
    });
    return <View className="tab-items-wrapper">
      {tabItems.map((item, index) => {
            return <View key={item.tabKey} className={activeIndex === index ? 'tab-items-active' : 'tab-items'} onClick={() => {
                    onTabClick(index, item);
                }} style={_remStyle({
                    width: index % 3 !== 2 ? 238 : 'auto'
                })}>
            <LText style={activeIndex === index ? styles.tagTextActive : styles.tagText}>{item.title}</LText>
          </View>;
        })}
    </View>;
};
const renderTagTab = (tabItems, activeIndex, onTabClick, tabTheme) => {
    const styles = _remStyleSheet({
        tag: {
            padding: 18,
            backgroundColor: tabTheme.tagBgColor,
            borderRadius: 12,
            backgroundImage: 'none'
        },
        tagActive: {
            padding: 18,
            border: `solid 1px ${tabTheme.titleActiveColor}`,
            backgroundColor: tabTheme.tagBgColor,
            borderRadius: 12
        },
        tagText: {
            fontSize: 24,
            lineHeight: 24,
            color: '#222222'
        },
        tagTextActive: {
            fontSize: 24,
            lineHeight: 24,
            color: tabTheme.titleActiveColor
        },
        lastOne: {
            marginRight: 0
        }
    });
    return <View className="tag-items-wrapper">
      {tabItems.map((item, index) => {
            const lastOne = index === tabItems.length - 1;
            return <View className="tag-tab-items" key={item.tabKey} style={flattenStyle([activeIndex === index ? styles.tagActive : styles.tag, lastOne ? styles.lastOne : {}])} onClick={() => {
                    onTabClick(index, item);
                }}>
            <LText style={activeIndex === index ? styles.tagTextActive : styles.tagText}>{item.title}</LText>
          </View>;
        })}
    </View>;
};
const renderImageTab = (tabItems, activeIndex, onTabClick) => {
    return <View className="tab-items-wrapper">
      <ImageTab activeIndex={activeIndex} onItemPress={onTabClick} data={tabItems}/>
    </View>;
};
const TabExpand = (props) => {
    const { open, tabItems, activeIndex, closeFloatingTab, tabStyle, onTabChange, tabTextType, theme, disableScroll, enableScroll } = props;
    const titleStyles = _remStyleSheet({
        tabTitleText: {
            fontSize: 32,
            lineHeight: 32,
            marginLeft: tabStyle === 'text' ? 20 : 30,
            marginTop: 38,
            fontWeight: '500'
        },
        tabTitleIcon: {
            marginRight: 14,
            marginTop: 14
        }
    });
    const onTabClick = useCallback((index, tabItem) => {
        if (onTabChange) {
            onTabChange(index, tabItem);
            closeFloatingTab();
        }
    }, [onTabChange]);
    useEffect(() => {
        if (disableScroll && enableScroll) {
            open ? disableScroll() : enableScroll();
        }
    }, [open]);
    if (!tabItems || !tabItems.length)
        return null;
    return <View x-if={open} className="container">
      <View className={tabTextType === 'text' ? 'background' : 'tag-background'}>
        {tabStyle === 'text' && tabTextType === 'text' && <View className="tabTitle">
            <LText type="title3" text="全部分类" color="#222222" style={titleStyles.tabTitleText}></LText>
            <Button style={titleStyles.tabTitleIcon} onPress={closeFloatingTab}>
              <LIcon name={'guanbixian'} type="body2" color="#D6D6D6" size={32}/>
            </Button>
          </View>}
        {tabStyle === 'text' ? tabTextType === 'text' ? renderTextTab(tabItems, activeIndex, onTabClick, theme) : renderTagTab(tabItems, activeIndex, onTabClick, theme) : renderImageTab(tabItems, activeIndex, onTabClick)}
        {tabStyle === 'text' && tabTextType === 'tag' && <View className="tabTagTitle">
            <Button style={titleStyles.tabTitleIcon} onPress={closeFloatingTab}>
              <LIcon uri={'https://p0.meituan.net/ingee/8459433a45f064d65293669d3239b5213878.png'} type="body2" style={isWeb ? {
                transform: 'rotate(180deg)'
            } : {
                transform: [{
                        rotate: '180deg'
                    }]
            }} color="#222222" size={14}/>
            </Button>
          </View>}
      </View>
      <View className="horizontaldirecotryMdoal" onClick={closeFloatingTab}/>
    </View>;
};
const TabExpandCom = memo(TabExpand);
export default TabExpandCom;
